
/* ======================== Recaptcha ========================= */

require('./_axios')
require('./_progress')


/**
 * @param form {Element} form that requires google recaptcha checking
 * @param urlPublicKey {String} url to fetch google recaptcha public key
 * @param urlSubmit {String} url to fetch google recaptcha public key
 * @param onSuccess {Function} executes on success submit form, passed axios response
 * @param onCatch {Function} executes on error submit form, passed axios error
 * @return {Promise<void>}
 * @constructor
 */
const Recaptcha = async ({ form, urlPublicKey, urlSubmit, onSuccess, onCatch }) => {

  // check arguments
  if (!form) {
    console.error('Form not found')
    return
  }
  if (!urlPublicKey) {
    console.error('Form attribute "data-url-key" not found')
    return
  }
  if (!urlSubmit) {
    console.error('Form attribute "data-url-submit" not found')
    return
  }

  // hide google badge
  const hideGoogleBadge = () => {
    const style = document.createElement('style')
    style.appendChild(document.createTextNode('.grecaptcha-badge{visibility:hidden}'))
    document.head.appendChild(style)
  }

  // load google API js script
  const loadRecaptchaApiJs = recaptcha_key => new Promise(resolve => {
    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?render=${recaptcha_key}`
    script.onload = e => resolve()
    document.head.appendChild(script)
  })

  // on submit handler
  const addSubmitHandler = recaptcha_key => {
    form.addEventListener('submit', e => {
      e.preventDefault()

      form.classList.add('is-loading')

      // get recaptcha token and submit form data
      grecaptcha.ready(() => {
        grecaptcha.execute(recaptcha_key, { action: 'submit' })
          .then(token => {

            // collect form data
            const formData = new FormData()
            form.querySelectorAll('[name]').forEach(el => formData.append(el.getAttribute('name'), el.value))
            formData.append('g-recaptcha-response', token) // add recaptcha
            // console.log('submit form', formData.values())

            axios.post(urlSubmit, formData)
              .then(res => {
                if (onSuccess) onSuccess(res)
              })
              .catch(err => {
                console.error(err)
                if (onCatch) onCatch(err)
              })
              .finally(() => form.classList.remove('is-loading'))

          })
          .catch(err => {
            console.error(err)
            if (onCatch) onCatch(err)
            form.classList.remove('is-loading')
          })
      })

    })

  }



  // 1. fetch recaptcha public key
  axios.get(urlPublicKey)
    .then(async res => {

      const recaptcha_key = res.data?.recaptcha_key
      if (!recaptcha_key) {
        console.error('Failed to fetch recaptcha public key')
        return false
      }

      // hide google badge (optionally)
      hideGoogleBadge()

      // 2. load recaptcha api script
      await loadRecaptchaApiJs(recaptcha_key)

      // 3. attach submit handler
      addSubmitHandler(recaptcha_key)
    })
    .catch(err => console.error('Failed to fetch recaptcha public key', err))


}


export { Recaptcha }
